import { createFileRoute } from '@tanstack/react-router'
import { Link, useIsRTL, useTranslation } from '@spcc/core'
import type { TFunction } from 'i18next'
import { KioskLoginSection } from '@spcc/domains/auth'
import { getTextDirection } from '@/lib/text-direction'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

const LOGIN_FOOTER_LINK = {
  to: '/privacy',
  labelKey: 'privacy.link',
}

function getLoginWrapperClassName(): string {
  return 'relative min-h-screen'
}

function getLoginFooterClassName(): string {
  return 'absolute inset-x-0 bottom-6 flex justify-center'
}

function renderLoginFooter(t: TFunction): JSX.Element {
  return (
    <footer className={getLoginFooterClassName()}>
      <Link
        to={LOGIN_FOOTER_LINK.to}
        className="text-xs font-medium text-muted-foreground hover:text-foreground transition-colors"
      >
        {t(LOGIN_FOOTER_LINK.labelKey)}
      </Link>
    </footer>
  )
}

function LoginPage() {
  const { t } = useTranslation()
  const isRTL = useIsRTL()
  const direction = getTextDirection(isRTL)

  return (
    <div className={getLoginWrapperClassName()} dir={direction}>
      <KioskLoginSection />
      {renderLoginFooter(t)}
    </div>
  )
}
